var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.d != null)?_c('span',{staticClass:"sd-delta",class:_vm.d >= 0 ? 'up' : 'dn'},[_vm._v(_vm._s(_vm.d >= 0 ? '▲' : '▼')+" "),_c('span',{staticClass:"num-ltr"},[_vm._v(_vm._s(Math.abs(Math.round(_vm.d * 10) / 10))+_vm._s(_vm.unit || ''))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }